import { lazy } from 'react';

export const LotSizeCalculatorPageLazy = lazy(
    () => import('./lot-size-calculator-page'),
);
